// Recovered compiled webpack factory 59686. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { t: () => n });
  let n = (0, i(12115).createContext)(null);
}
